import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "list"];

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();

    for (const element of this.listTarget.children) {
      const text = element.textContent.trim().toLowerCase();

      element.hidden = !!query && !text.includes(query);
      element.selected = false;
    }
  }

  clear() {
    this.inputTarget.value = "";
    this.filter();
  }
}
